import { USER_HIDE_WORK_ON_PC_MOBILE_POPUP } from '@/store/actions/user';

/**
 * @description Примесь мобильного вида.
 */
export default {
  computed: {
    /**
     * @description Показывать всплывающее окно скачивания мобильного приложения.
     * @returns {boolean}
     */
    shownWorkOnPCMobilePopup() {
      return this.$store.getters.shownWorkOnPCMobilePopup
        && this.isMobile;
    },
  },
  methods: {
    /**
     * @description Обработать закрытие всплывающего окна скачивания мобильного приложения.
     * @returns {void}
     */
    onCloseWorkOnPCMobileAppPopup() {
      this
        .$userGateway
        .closeWorkOnPCMobilePopup()
        .then(() => {
          this.$store.dispatch(USER_HIDE_WORK_ON_PC_MOBILE_POPUP);
        });
    },
  },
};
